import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {NgbModule, NgbAccordionModule, NgbDatepickerModule, NgbProgressbarModule } from '@ng-bootstrap/ng-bootstrap';
import {NgbdModalModule} from '../modal/modal.module';
import {AngularEditorModule} from '@kolkov/angular-editor';
import {PipesModule} from '../pipes/pipes.module';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {HttpClientModule} from '@angular/common/http';
import {ToastrModule } from 'ngx-toastr';
import {DatePickerComponent} from './date-picker/date-picker.component';
import {DropDownComponent} from './drop-down/drop-down.component';
import {LoadingComponent} from './loading/loading.component';
import {ReactiveFormsTextInputComponent} from './reactive-forms-text-input/reactive-forms-text-input.component';
import {RecommendedDecisionMgrComponent} from './recommended-decision-mgr/recommended-decision-mgr.component';
import {RiqSliderComponent} from './riq-slider/riq-slider.component';
import {TextInputComponent} from './text-input/text-input.component';
import {ToggleComponent} from './toggle/toggle.component';
import {UsersListComponent} from './users-list/users-list.component';
import {PropertyListComponent} from './property-list/property-list.component';
import {ScreeningListComponent} from './screening-list/screening-list.component';
import {PaginationTopComponent} from './pagination-top/pagination-top.component';
import {UsersUploadComponent} from './users-upload/users-upload.component';
import {NotesPaneComponent} from './notes-pane/notes-pane.component';
import {PackageListComponent} from './package-list/package-list.component';
import {MinValueDirective} from './validators/min-value.directive';
import {AddressInputComponent} from './address-input/address-input.component';
import {EmailDirective} from './validators/email.directive';
import {AddressInputModalComponent} from './address-input-modal/address-input-modal.component';
import {ValidNameDirective} from './validators/valid-name.directive';
import {MaxValueDirective} from './validators/max-value.directive';
import {NumbersOnlyDirective} from './validators/numbers-only.directive';
import {SsnFormatInputDirective} from './validators/ssn-format-input.directive';
import { DigitOnlyDirective } from './directives/digit-only.directive';
import { DobValidatorDirective } from './validators/dob-validator.directive';
import { VerificationQuestionGridComponent } from './verification-question-grid/verification-question-grid.component';
import { ResidenceVerificationFormComponent } from './residence-verification-form/residence-verification-form.component';
import { EmploymentVerificationFormComponent } from './employment-verification-form/employment-verification-form.component';
import { VerificationCallComponent } from './verification-call/verification-call.component';
import {DragDropLocationComponent} from './drag-drop-location/drag-drop-location.component';
import { ApplicantDocumentsComponent } from './applicant-documents/applicant-documents.component';
import { EmploymentDataComponent } from './employment-data/employment-data.component';
import { ResidentDataComponent } from './resident-data/resident-data.component';
import { ChangeLogComponent } from './change-log/change-log.component';
import { QuickFilterComponent } from './quick-filter/quick-filter.component';
import { RiqAlertComponent } from './riq-alert/riq-alert.component';
import { IntegrationsComponent } from './integrations/integrations.component';
import { PropertyDecisionMgrComponent } from './property-decision-mgr/property-decision-mgr.component';
import { NoPasteDirective } from './directives/no-paste.directive';
import { ProcessorReportDownloadComponent } from './processor-report-download/processor-report-download.component';
import { RentmanIntegrationPaneComponent } from './integrations/rentman/rentman-integration-pane/rentman-integration-pane.component';
import { RentmanPropertyMappingModalComponent } from './integrations/rentman/rentman-property-mapping-modal/rentman-property-mapping-modal.component';
import { YardiIntegrationPaneComponent } from './integrations/yardi/yardi-integration-pane/yardi-integration-pane.component';
import { YardiPropertyMappingModalComponent } from './integrations/yardi/yardi-property-mapping-modal/yardi-property-mapping-modal.component';
import { PhoneNumberDirective } from './validators/phone-number.directive';
import { ProcessorReportDialogComponent } from './processor-report-dialogs/processor-report-dialog/processor-report-dialog.component';
import { VendorSearchBreakdownDialogComponent } from './processor-report-dialogs/vendor-search-breakdown-dialog/vendor-search-breakdown-dialog.component';
import { MaterialModule } from './material.module';
import { GroupApplicantComponent } from './group-applicant/group-applicant.component';
import { ApiCredentialsReportDialogComponent } from './processor-report-dialogs/api-credentials-report-dialog/api-credentials-report-dialog.component';
import { PreventDblClickDirective } from './directives/prevent-dbl-click.directive';
import { PopOutPanelComponent } from './pop-out-panel/pop-out-panel.component';
import { WatchTowerCardComponent } from './watch-tower-card/watch-tower-card.component';
import { ClientTatBreakdownDialogComponent } from './processor-report-dialogs/client-tat-breakdown-dialog/client-tat-breakdown-dialog.component';
import { DynamicTableComponent } from './dynamic-table/dynamic-table.component';
import { EmailQueueComponent } from './email-queue/email-queue.component';
import { EmailErrorDialogComponent } from './email-queue/email-error-dialog/email-error-dialog.component';
import { GroupIncomeComponent } from './group-income/group-income.component';
import { ScreeningNotesComponent } from './screening-notes/screening-notes.component';
import { SendEmailPacketComponent } from './email-queue/send-email-packet/send-email-packet.component';
import { RequiredSometimesDirective } from './validators/required-sometimes.directive';
import { ScreeningEmailsComponent } from './email-queue/screening-emails/screening-emails.component';
import { ProductBillingComponent } from './product-billing/product-billing.component';
import { ProductBillingModalComponent } from './product-billing-modal/product-billing-modal.component';
import { IncomeSourceModalComponent } from './income-source-modal/income-source-modal.component';
import { IncomeSourceGroupsModalComponent } from './income-source-groups-modal/income-source-groups-modal.component';
import { IncomeSourceListComponent } from './income-source-list/income-source-list.component';
import { ProcessorAuditDialogComponent } from './processor-report-dialogs/processor-audit-dialog/processor-audit-dialog.component';
import { RiqSliderV2Component } from './riq-slider-v2/riq-slider-v2.component';
import { ScoringModelListComponent } from './scoring-model-list/scoring-model-list.component';
import { ArgylePayrollSyncModalComponent } from './argyle-payroll-sync-modal/argyle-payroll-sync-modal.component';
import { PayrollSyncComponent } from './income-stream-components/payroll-sync/payroll-sync.component';
import { PaystubUploadComponent } from './income-stream-components/paystub-upload/paystub-upload.component';
import { BankAccountSyncComponent } from './income-stream-components/bank-account-sync/bank-account-sync.component';
import { WorkNumberComponent } from './income-stream-components/work-number/work-number.component';
import { W2UploadComponent } from './income-stream-components/w2-upload/w2-upload.component';
import { Upload1099Component } from './income-stream-components/1099-upload/1099-upload.component';
import { SopChatPanelComponent } from './sop-chat-panel/sop-chat-panel.component';
import { DivDocumentsReportDialogComponent } from './processor-report-dialogs/div-documents-report-dialog/div-documents-report-dialog.component';
import { DivInviteReportDialogComponent } from './processor-report-dialogs/div-invite-report-dialog/div-invite-report-dialog.component';



@NgModule({
    declarations: [
        DatePickerComponent,
        DropDownComponent,
        LoadingComponent,
        ReactiveFormsTextInputComponent,
        RecommendedDecisionMgrComponent,
        RiqSliderComponent,
        RiqSliderV2Component,
        ScoringModelListComponent,
        TextInputComponent,
        ToggleComponent,
        UsersListComponent,
        PropertyListComponent,
        ScreeningListComponent,
        PaginationTopComponent,
        UsersUploadComponent,
        NotesPaneComponent,
        PackageListComponent,
        MinValueDirective,
        AddressInputComponent,
        EmailDirective,
        AddressInputModalComponent,
        ProductBillingModalComponent,
        ValidNameDirective,
        MaxValueDirective,
        NumbersOnlyDirective,
        SsnFormatInputDirective,
        DigitOnlyDirective,
        DobValidatorDirective,
        VerificationQuestionGridComponent,
        ResidenceVerificationFormComponent,
        EmploymentVerificationFormComponent,
        VerificationCallComponent,
        DragDropLocationComponent,
        ApplicantDocumentsComponent,
        EmploymentDataComponent,
        ResidentDataComponent,
        ChangeLogComponent,
        QuickFilterComponent,
        RiqAlertComponent,
        IntegrationsComponent,
        PropertyDecisionMgrComponent,
        NoPasteDirective,
        ProcessorReportDownloadComponent,
        RentmanIntegrationPaneComponent,
        RentmanPropertyMappingModalComponent,
        YardiIntegrationPaneComponent,
        YardiPropertyMappingModalComponent,
        PhoneNumberDirective,
        PreventDblClickDirective,
        ProcessorReportDialogComponent,
        ProcessorAuditDialogComponent,
        VendorSearchBreakdownDialogComponent,
        GroupApplicantComponent,
        ApiCredentialsReportDialogComponent,
        PopOutPanelComponent,
        WatchTowerCardComponent,
        ClientTatBreakdownDialogComponent,
        DynamicTableComponent,
        EmailQueueComponent,
        EmailErrorDialogComponent,
        SendEmailPacketComponent,
        GroupIncomeComponent,
        ScreeningNotesComponent,
        RequiredSometimesDirective,
        ScreeningEmailsComponent,
        ProductBillingComponent,
        IncomeSourceModalComponent,
        IncomeSourceGroupsModalComponent,
        IncomeSourceListComponent,
        ArgylePayrollSyncModalComponent,
        PayrollSyncComponent,
        PaystubUploadComponent,
        BankAccountSyncComponent,
        WorkNumberComponent,
        W2UploadComponent,
        Upload1099Component,
        SopChatPanelComponent,
        DivDocumentsReportDialogComponent,
        DivInviteReportDialogComponent
    ],
    imports: [
        MaterialModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        NgbModule,
        NgbdModalModule,
        AngularEditorModule,
        PipesModule,
        BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        HttpClientModule,
        ReactiveFormsModule,
        NgbDatepickerModule,
        NgbProgressbarModule,
        // RouterModule.forRoot(routes),
        ToastrModule.forRoot({
            positionClass: 'toast-top-right',
            preventDuplicates: false,
        }), // ToastrModule added
    ],
    exports: [
        DatePickerComponent,
        DropDownComponent,
        LoadingComponent,
        ReactiveFormsTextInputComponent,
        RecommendedDecisionMgrComponent,
        RiqSliderComponent,
        RiqSliderV2Component,
        ScoringModelListComponent,
        TextInputComponent,
        ToggleComponent,
        UsersListComponent,
        PropertyListComponent,
        ScreeningListComponent,
        PaginationTopComponent,
        UsersUploadComponent,
        NotesPaneComponent,
        PackageListComponent,
        MinValueDirective,
        AddressInputComponent,
        EmailDirective,
        ValidNameDirective,
        NumbersOnlyDirective,
        PhoneNumberDirective,
        SsnFormatInputDirective,
        NoPasteDirective,
        DigitOnlyDirective,
        DobValidatorDirective,
        PreventDblClickDirective,
        VerificationQuestionGridComponent,
        ResidenceVerificationFormComponent,
        EmploymentVerificationFormComponent,
        DragDropLocationComponent,
        ApplicantDocumentsComponent,
        EmploymentDataComponent,
        ResidentDataComponent,
        ChangeLogComponent,
        QuickFilterComponent,
        IntegrationsComponent,
        PropertyDecisionMgrComponent,
        ProcessorReportDownloadComponent,
        PhoneNumberDirective,
        ProcessorReportDialogComponent,
        ProcessorAuditDialogComponent,
        VendorSearchBreakdownDialogComponent,
        GroupApplicantComponent,
        MaterialModule,
        AngularEditorModule,
        PipesModule,
        BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        HttpClientModule,
        ReactiveFormsModule,
        PopOutPanelComponent,
        WatchTowerCardComponent,
        ClientTatBreakdownDialogComponent,
        DynamicTableComponent,
        EmailQueueComponent,
        EmailErrorDialogComponent,
        ScreeningNotesComponent,
        RequiredSometimesDirective,
        ScreeningEmailsComponent,
        ProductBillingComponent,
        ProductBillingModalComponent,
        IncomeSourceModalComponent,
        IncomeSourceGroupsModalComponent,
        IncomeSourceListComponent,
        RiqAlertComponent,
        ArgylePayrollSyncModalComponent,
        PayrollSyncComponent,
        PaystubUploadComponent,
        BankAccountSyncComponent,
        WorkNumberComponent,
        W2UploadComponent,
        Upload1099Component,
        SopChatPanelComponent,
        DivDocumentsReportDialogComponent,
        DivInviteReportDialogComponent
    ]
})
export class SharedComponentsModule {
}
